import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CTASection from "@/components/CTASection";
import AIChatbot from "@/components/AIChatbot";
import CustomCursor from "@/components/CustomCursor";
import Home from "@/pages/Home";
import Pricing from "@/pages/Pricing";
import Tour from "@/pages/Tour";
import Contact from "@/pages/Contact";
import Careers from "@/pages/Careers";
import Catering from "@/pages/Catering";
import Decor from "@/pages/Decor";
import Gallery from "@/pages/Gallery";

function App() {
  return (
    <div className="App min-h-screen bg-ivory">
      <CustomCursor />
      <BrowserRouter>
        <SmoothScroll>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/catering" element={<Catering />} />
              <Route path="/decor" element={<Decor />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/tour" element={<Tour />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/careers" element={<Careers />} />
            </Routes>
          </main>
          {/* Final CTA before footer */}
          <CTASection
            dark={false}
            overline="Say Hello"
            heading="We can't wait to host your celebration."
            body="Reach out, request pricing, or schedule your private tour of Vista Banquet Hall."
            actions={[
              { to: "/contact", label: "Contact Us", primary: true },
              { to: "/tour", label: "Schedule a Tour" },
            ]}
            testId="cta-before-footer"
          />
          <Footer />
          <AIChatbot />
        </SmoothScroll>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
